import axios from 'axios';

export const getStyleListMethod = (url: string) => axios.get(url + '/api/v1/get-style-list');
